// extracted by mini-css-extract-plugin
module.exports = {"official-representative":"_32bbee5fda--official-representative--Fq1eI","link":"_32bbee5fda--link--gCFNZ"};